import { objectSpread2 as _objectSpread2 } from './_virtual/_rollupPluginBabelHelpers.mjs';
import React, { useContext } from 'react';
import { ThemeContext } from 'styled-components';
import { SizeWrapper, TouchWrapper } from './styles/styledComponents.mjs';
import { jsx, jsxs } from 'react/jsx-runtime';

var Svg18ImageG = /*#__PURE__*/React.memo(function (props) {
  useContext(ThemeContext);
  props.iconColor;
  var component = /*#__PURE__*/jsx("svg", _objectSpread2(_objectSpread2({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 18 18"
  }, props), {}, {
    children: /*#__PURE__*/jsxs("g", {
      fill: "none",
      fillRule: "evenodd",
      transform: "translate(2 2)",
      children: [/*#__PURE__*/jsx("path", {
        fill: props.iconColor ? props.iconColor : "#010505",
        fillRule: "nonzero",
        d: "M12.41 1.2c.22 0 .4.18.4.4v10.81c0 .22-.18.4-.4.4H1.6c-.22 0-.4-.18-.4-.4V1.6c0-.22.18-.4.4-.4zm0-1.2H1.6C.72 0 0 .72 0 1.6v10.81c0 .88.72 1.6 1.6 1.6h10.81c.88 0 1.6-.72 1.6-1.6V1.6c0-.88-.72-1.6-1.6-1.6"
      }), /*#__PURE__*/jsx("circle", {
        cx: 10.16,
        cy: 4.05,
        r: 1.05,
        fill: props.iconColor ? props.iconColor : "#010505",
        fillRule: "nonzero"
      }), /*#__PURE__*/jsx("path", {
        stroke: props.iconColor ? props.iconColor : "#010505",
        strokeLinejoin: "round",
        strokeWidth: 1.2,
        d: "m13.22 11.04-3.18-3.18-1.97 1.98-3.56-3.56-3.8 3.79"
      })]
    })
  }));
  if (props.size) {
    component = /*#__PURE__*/React.createElement(SizeWrapper, {
      size: props.size
    }, component);
  }
  if (props.touch) {
    component = /*#__PURE__*/React.createElement(TouchWrapper, {
      size: props.size,
      touch: props.touch
    }, component);
  }
  return component;
});
var Svg18ImageG$1 = Svg18ImageG;

export { Svg18ImageG$1 as default };
